import { MatError } from "@angular/material/form-field";
import { MatRadioModule } from "@angular/material/radio";
import { TranslateModule } from "@ngx-translate/core";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { Component, forwardRef, input, output } from "@angular/core";

import { ReactiveFormsBaseComponent } from "../../base-components";
import { LocalizedNamePipe, ValidationHandlerPipe } from "../../pipes";

import { Checkbox } from "src/app/core";

@Component({
  selector: "app-radio-button",
  standalone: true,
  imports: [MatRadioModule, MatError, ReactiveFormsModule, TranslateModule, LocalizedNamePipe, ValidationHandlerPipe],
  templateUrl: "./radio-button.component.html",
  styleUrl: "./radio-button.component.scss",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioButtonComponent),
      multi: true,
    },
  ],
})
export class RadioButtonComponent extends ReactiveFormsBaseComponent {
  readonly label = input.required<string>();
  readonly options = input.required<Checkbox[]>();
  readonly isHorizontal = input(true);

  readonly isChecked = output<Checkbox["id"]>();
}
